import { Controller } from "stimulus"

// Search and sort on /plugins/all/ (pages/plugins/all.html). The rows are
// server-rendered, most downloaded first, each with data-search (the name,
// author, id and description in lowercase), data-name, data-downloads and
// data-listed. This hides the rows that don't contain every word of the
// query and reorders them for the chosen sort. The url's ?q= and ?sort=new
// set the initial state (the index page's "View all" links use them) and
// follow the choices, so a reload or a Turbo restore comes back the same.
export default class PluginDirectoryController extends Controller {

  static get targets() {
    return ['query', 'list', 'empty', 'term', 'sort']
  }

  connect() {
    const params = new URLSearchParams(window.location.search)
    this.queryTarget.value = params.get('q') || ''
    this.apply(params.get('sort') === 'new' ? 'new' : 'popular')
  }

  filter() {
    this.apply(this.current)
  }

  sort(event) {
    this.apply(event.currentTarget.dataset.sort)
  }

  apply(sort) {
    this.current = sort
    const query = this.queryTarget.value.trim().toLowerCase()
    const words = query.split(/\s+/).filter(Boolean)
    const key = sort === 'new'
      ? (row) => row.dataset.listed
      : (row) => Number(row.dataset.downloads)
    const rows = Array.from(this.listTarget.children).sort((a, b) => {
      if (key(a) !== key(b)) return key(a) < key(b) ? 1 : -1
      return a.dataset.name.localeCompare(b.dataset.name)
    })

    let shown = 0
    rows.forEach((row) => {
      const match = words.every((word) => row.dataset.search.includes(word))
      row.hidden = !match
      if (match) shown += 1
      this.listTarget.appendChild(row)
    })

    this.sortTargets.forEach((button) => button.classList.toggle('active', button.dataset.sort === sort))
    this.termTarget.textContent = this.queryTarget.value.trim()
    this.emptyTarget.hidden = shown > 0

    const url = new URL(window.location.href)
    query ? url.searchParams.set('q', this.queryTarget.value.trim()) : url.searchParams.delete('q')
    sort === 'new' ? url.searchParams.set('sort', 'new') : url.searchParams.delete('sort')
    // Turbo keeps its restoration identifier in history.state: pass it through.
    history.replaceState(history.state, '', url)
  }
}
